import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ParentStatistics, StatisticItemKey, StatisticSectionKey } from '~/components/Statistics';
import {
    SearchContext,
    SearchContextType,
    useSearchClinic,
    useSearchPCP,
    useSearchSort,
} from '~/services';
import { prepareStatsLink } from '~/util';

interface StatisticsProps {
    isResultsPage?: boolean;
}
export function Statistics({ isResultsPage = false }: StatisticsProps) {
    const location = useLocation();
    const history = useHistory();
    const { clinic } = useSearchClinic();
    const { PCP } = useSearchPCP();
    const { searchValues, resetPagination } = React.useContext(SearchContext) as SearchContextType;
    const { resetSort } = useSearchSort();

    function getLink(
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        section: StatisticSectionKey,
        item: StatisticItemKey
    ) {
        e.preventDefault();
        resetPagination();
        if (isResultsPage) {
            history.replace({
                pathname: '/patients',
                search: `?${prepareStatsLink(searchValues, section, item)}`,
            });
        } else {
            resetSort();
            history.push({
                pathname: '/patients',
                search: `?${prepareStatsLink({ clinic, PCP }, section, item)}`,
            });
        }
    }

    function getActiveBadge(section: StatisticSectionKey, item: StatisticItemKey) {
        const params = location.search
            .split('&')
            .filter((x) => x.includes(section))
            .map((x) => x.split('='));
        return params.length > 0 && parseInt(params[0][1]) === item ? 'badge-outline-' : 'bg-';
    }

    return (
        <ParentStatistics
            evt={null}
            patientView={false}
            getLink={getLink}
            getActiveBadge={getActiveBadge}
            isResultsPage={isResultsPage}
        />
    );
}
